export default __webpack_public_path__ + "static/media/sketch-international-tn.31e91adf.png";